import { createContext } from 'react';

const ColorContext = createContext({ color: 0x00ffff });

export default ColorContext;
